$('body').addClass('hypothesis-14-cart-nudges');
// get the current path
const currentPath = window.location.pathname.split('/')[1];
console.log(currentPath); // e.g., 'nl', 'de', etc.
window.currentPath = currentPath;
function detectLocale() {
  let locale = 'en';
  if (window.location.pathname.startsWith('/nl')) locale = 'nl';
  else if (window.location.pathname.startsWith('/de')) locale = 'de';
  else if (window.location.pathname.startsWith('/en-gb')) locale = 'en-gb';
  return locale;
}
const locale = detectLocale();
console.log(locale,"localelocale")
// Function to get a cookie by name
function getCookie(name) {
const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
return match ? decodeURIComponent(match[2]) : null;
}
// Function to set a cookie with expiration in minutes
function setCookie(name, value, minutes) {
const d = new Date();
d.setTime(d.getTime() + (minutes * 60 * 1000));
const expires = "expires=" + d.toUTCString();
document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

// Function to determine if popup should be shown based on last shown time
function shouldShowPopup() {
const timestamp = getCookie("cro-welcome");
if (!timestamp) return true; // First time visit

const lastShown = parseInt(timestamp, 10);
const now = Math.floor(Date.now() / 1000);

// Show only if 10 minutes (600 seconds) have passed
return (now - lastShown) > 600;
} 

if (shouldShowPopup()) {
const path = (locale && locale !== 'en') ? `/${locale}/cart?view=cro-welcome-back` : `/cart?view=cro-welcome-back`;
fetch(path)
.then(response => {
    if (!response.ok) {
    throw new Error('Network response was not ok');
    }
    return response.text(); // We're expecting HTML as text
})
.then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // Modify this selector to match your product item wrapper
    const products = doc.querySelectorAll('.cart-item'); // Replace with your actual product selector
    const firstThreeProducts = Array.from(products).slice(0, 3);

    // Find the popup container
    const popupContainer = document.querySelector('.custom-cro-popup.custom-popup--right.custom-cropopup--welcome');

    if (popupContainer && products.length > 0) {
        popupContainer.appendChild(doc.querySelector(".custom-popup__wrapper"));
        popupContainer.style.display = "block";
        popupContainer.style.opacity = 1;
        setCookie("cro-welcome", Math.floor(Date.now() / 1000), 10);
        const array_for_freeshipping_99_custom = ['Czechia', 'Estonia', 'Hungary', 'Luxembourg', 'Slovakia', 'Monaco', 'Spain'];
        const array_for_freeshipping_49_custom = ['Germany', 'Netherlands', 'Belgium', 'Sweden', 'France', 'Denmark', 'Italy', 'Finland', 'Austria', 'Ireland', 'Switzerland', 'Poland', 'Portugal'];
        const array_for_freeshipping_42_custom = ['United Kingdom']
        // Detect country and cart data
        const countryData = window.jimmyjoy?.country_data?.detected_values;
        const cartData = window.jimmyjoy?.cart;

        if (!countryData || !cartData) {
        console.warn('Missing country or cart data');
        } else {
        const countryName = countryData.country_name;
        const cartTotalCents = Number(cartData.total_price) || 0;
        let cartTotalEuros = cartTotalCents / 100;
        if (countryName === "United Kingdom" && cartData.currency !== "GBP") {
            const EUR_TO_GBP = 0.885; 
            cartTotalEuros = cartTotalEuros * EUR_TO_GBP;
        }

        let FREE_SHIPPING_THRESHOLD_CUSTOM;

        if (array_for_freeshipping_99_custom.includes(countryName)) {
            FREE_SHIPPING_THRESHOLD_CUSTOM = 99;
        } else if (array_for_freeshipping_49_custom.includes(countryName)) {
            FREE_SHIPPING_THRESHOLD_CUSTOM = 49;
        } else if (array_for_freeshipping_42_custom.includes(countryName)){
            FREE_SHIPPING_THRESHOLD_CUSTOM = 42;
        }

        // Only call update if country is in either list
        if (FREE_SHIPPING_THRESHOLD_CUSTOM !== undefined) {
            updateFreeShippingBar(cartTotalEuros, FREE_SHIPPING_THRESHOLD_CUSTOM);
        } else {
            console.log('Country not eligible for free shipping threshold');
        }
    document.querySelector('.custom-cropopup--welcome').addEventListener('click', function() {
        const popup = document.querySelector('.custom-cro-popup.custom-popup--right.custom-cropopup--welcome');
        if (popup) {
            popup.style.transition = "opacity 0.2s ease";
            popup.style.opacity = 0;
            setTimeout(() => popup.style.display = "none", 200);
        }
        });
        }

        // Your update function (assuming defined somewhere)
        function updateFreeShippingBar(total, threshold) {
            
        const fill = document.getElementById('progress-fill');
        const message = document.getElementById('shipping-message');

        const progress = Math.min((total / threshold) * 100, 100);
        fill.style.width = `${progress}%`;

        const remaining = threshold - total;

        if (remaining > 0) {
            console.log("window.currentPath",window.currentPath)
            if(window.currentPath == "nl"){
            message.textContent = `Besteed nog €${remaining.toFixed(2)} voor gratis verzending!`;
            }else if(window.currentPath == "de"){
            message.textContent = `Gib noch €${remaining.toFixed(2)} aus für gratis Versand!`;
            }else if (window.currentPath == 'en-gb'){
                message.textContent = `Spend £${remaining.toFixed(2)} to get free shipping!`;
            }else{
            message.textContent = `Spend €${remaining.toFixed(2)} more to get free shipping!`;
            }
        } else {
        if(window.currentPath == "nl"){
            message.textContent = `Je hebt gratis verzending!`;
            }else if(window.currentPath == "de"){
            message.textContent = `Du erhältst gratis Versand!`;
            }else{
            message.textContent = `Great news! You get FREE SHIPPING!`;
            }
            document.querySelector(".custom-cro-popup .popup_image").classList.remove("hidden");
        }
        document.querySelector("#free-shipping-bar").style.display = "block";
        }
    } else {
    console.warn('Popup container not found');
    }
})
.catch(error => {
    console.error('Fetch error:', error);
});
}